export default {
  errorsRootKey: 'campaigns',
  resource: 'campaign-drafts',
  actions: ['show', 'destroy', 'create', 'update']
}
